import httpClient from "@/plugins/axios";
import moment from "moment";

export const translateText = async (sourceLang, targetLang, text) => {
    const response = await httpClient.post(`admin/v1/translate/`,
        {
            source_lang: sourceLang,
            target_lang: targetLang,
            text: text
        }
    );
    return response;
}
